import { createVNode as a, mergeProps as n } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UserMaleTwotoneStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return a(d, n(o, {
    icon: s
  }), null);
};
r.displayName = "UserMaleTwotoneStandard";
r.inheritAttrs = !1;
export {
  r as default
};
